module.exports = __webpack_public_path__ + "img/ascend_gold12.ceaf16ca.png";